import abilities from './abilities'
import account from './account'
import authentication from './authentication'
import notifications from './notifications'
import numbers from './numbers'
import roles from './roles'
import system from './system'

const init = ({dispatch}) => {
  console.log('global init')

  // Attempt to load user
  dispatch('getUser')

  // Load account
  if (localStorage.getItem('accountId')) {
    const accountId = localStorage.getItem('accountId')
    dispatch('setAccount', accountId)
  }
}

export default {
  init,
  ...abilities,
  ...account,
  ...authentication,
  ...notifications,
  ...numbers,
  ...roles,
  ...system,
}
